import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import MaterialPagination from "../../../styles/materialPagination";
import { Helmet } from "react-helmet-async";
import ExchangeProfitFilter from "./ExchangeProfitFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import ExchangeProfitList from "./ExchangeProfitList";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { firstDayOfMonth, lastDayOfMonth } from "../../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

import { StyledExchangeProfitWrapper } from "./styledExchangeProfit";

const ExchangeProfitContainer = () => {
  const { t } = useTranslation("exchangerPage");
  const [exchangesProfits, setExchangesProfits] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "exchange-profit", false, true),
    "currency": checkFilterItem(history, "currency", ""),
    "service": checkFilterItem(history, "service", ""),
    "dateFrom": checkFilterItem(history, "dateFrom", firstDayOfMonth()),
    "dateTo": checkFilterItem(history, "dateTo", lastDayOfMonth())
  });

  const fetchProfit = () => {
    let filterUrl = fetchFilterData(filterData);

    history.replace(filterUrl);

    axios.get("/api/exchanges/profits" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {

        setExchangesProfits(response.data["profits"]);
        setTotalPageCount(response.data["totalPageCount"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };

  useEffect(() => {
    fetchProfit();
  }, [filterData]);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledExchangeProfitWrapper>
        <Helmet>
          <title>{t("profit.meta.title")}</title>
        </Helmet>
        <div className="exchange-profit-stabling-head">
          <ExchangeProfitFilter
            filterData={filterData}
            setFilterData={setFilterData}
            t={t}
          />
          <ItemsPerPageSelect
            itemsPerPage={filterData.itemsPerPage}
            setItemsPerPage={(data) => setFilterData({
              ...filterData,
              "itemsPerPage": data,
              page: 1
            })}
          />
        </div>
        <FilterAppliedList
          filterData={filterData}
          setFilterData={setFilterData}
        />
        <ExchangeProfitList
          notification={notification}
          setNotification={setNotification}
          exchangesProfits={exchangesProfits}
          filterData={filterData}
          t={t}
        />
        {totalPageCount > 0 &&
          <MaterialPagination
            count={totalPageCount}
            shape="rounded"
            page={filterData.page}
            onChange={(event, page) => onChangePage(event, page)}
          />
        }
      </StyledExchangeProfitWrapper>
    </>
  );
};

export default ExchangeProfitContainer;